<!-- Sidebar Navigation end-->
<div class="page-content">
  <!-- Page Header-->
  <div class="page-header no-margin-bottom">
    <div class="container-fluid">
      <h2 class="h5 no-margin-bottom">My Account</h2>
    </div>
  </div>

  <section class="pt-20">
    <div class="container-fluid" *ngIf="!upgrade">
      <div class="row">
        <!-- Basic Form-->
        <div class="col-lg-6">
          <div class="block">
            <div class="block-body" *ngIf="form">
              <form [formGroup]="form" (ngSubmit)="update()" novalidate>
                <ng-container *ngIf="errors$ | async as errors">
                  <ul class="error-list">
                    <li *ngFor="let item of errorItems">{{ item }}</li>
                  </ul>
                </ng-container>
                <div class="form-group">
                  <label for="form-control-label">User Name</label>
                  <input type="text" class="form-control" formControlName="user_name" />
                  <div *ngIf="f.user_name.invalid && (f.user_name.dirty || f.user_name.touched)">
                    <div *ngIf="f.user_name.errors" class="required-text">
                      <div *ngIf="f.user_name.errors.minlength">Must be minimum of 8 alphanumeric characters.</div>
                      <div *ngIf="f.user_name.errors.maxlength">Must be max of 255 alphanumeric characters.</div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="form-control-label">First Name</label>
                  <input type="text" class="form-control" formControlName="first_name" />
                  <div *ngIf="f.first_name.invalid && (f.first_name.dirty || f.first_name.touched)">
                    <div *ngIf="f.first_name.errors" class="required-text">
                      <div *ngIf="f.first_name.errors.required">Please enter your first name.</div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="form-control-label">Last Name</label>
                  <input type="text" class="form-control" formControlName="last_name" />
                  <div *ngIf="f.last_name.invalid && (f.last_name.dirty || f.last_name.touched)">
                    <div *ngIf="f.last_name.errors" class="required-text">
                      <div *ngIf="f.last_name.errors.required">Please enter your last name.</div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <button
                    class="btn btn-primary w-100 mb-10"
                    type="submit"
                    [disabled]="(loading$ | async) || !form.valid"
                  >
                    <span *ngIf="loading$ | async">Loading..</span>
                    <span *ngIf="!(loading$ | async)">Update</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row" *ngIf="plan && subscription">
            <div class="col-md-12">
              <div class="plan-item">
                <div align="center">
                  Current Plan
                  <ng-container *ngIf="plan.status === 'LAPSED'">
                    <div class="public-user-block mt-3">
                      <div class="contributions">EXPIRED</div>
                    </div>
                  </ng-container>
                </div>
                <br />
                <h3>
                  {{ subscription.title }}
                </h3>
                <small *ngIf="currentSubscription" class="text-success">
                  Active until
                  {{ currentSubscription.expires_at | date:'MMM d, y' }}

                  <span class="text-muted">
                    (UTC:
                    {{ currentSubscription.expires_at | date:'MMM d, y':'UTC' }})
                  </span>
                </small>
                <div>
                  <br />
                  <!-- <button type="button" class="btn btn-primary" (click)="upgrade = true">
                    CHANGE PLAN
                  </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- Basic Form-->
        <div class="col-lg-6">
          <div class="block">
            <div class="block-body" *ngIf="form">
              <button routerLink="/subscription" class="btn btn-primary w-100 mb-10" type="submit">
                Upgrade to Premium Account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid" *ngIf="upgrade">
      <button type="button" (click)="upgrade = false" class="btn btn-primary">Back</button> <br /><br />
      <div class="row" *ngIf="subscription$ | async">
        <div class="col-md-4" *ngFor="let subscription of subscription$ | async">
          <div class="plan-item">
            <h3>
              {{ subscription.title }}
            </h3>
            <div>
              <br />
              <button
                type="button"
                class="btn btn-primary"
                (click)="changePlan(plan.id, subscription.id)"
                *ngIf="subscription.id !== plan.id"
              >
                CHOOSE PLAN
              </button>
              <button type="button" class="btn btn-warning" disabled *ngIf="subscription.id === plan.id">
                CURRENT PLAN
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
